import { memo } from "react";
import CustomImage from "./Image";
import { loader } from "@/assets";

const Loader = memo(() => (
  <CustomImage
    className="size-20 object-contain"
    src={loader}
    alt="Loading..."
  />
));

export default Loader;
